import { makeStyles } from "@material-ui/core";

export const linkedAssetsStyle = makeStyles((theme) => ({
    itemIcon: {
        paddingRight: '1em'
    },
    itemLabel: {
        fontWeight: 600
    },
    autoComplete: {
        backgroundColor: theme.palette.background.default,
        margin: '0.5rem 0 ',
        padding: '0.5rem 0 0.5rem 0.5rem',
        color: theme.palette.primary.main,
        borderRadius: '4px',

        '&.MuiOutlinedInput-adornedEnd': {
            backgroundColor: theme.palette.background.default,
        },
        '&.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root': {
            padding: '0 !important',
        },
        '&.MuiAutocomplete-inputRoot': {
            padding: '0 !important',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
        },
        '& fieldset': {
            border: 'none'
        },        
        '& .MuiChip-root': {
            backgroundColor: 'white',
            borderRadius: '3px',
            color: theme.palette.primary.main,
            fontWeight: 400
        }
    },
    alertWrapper: {
        position: 'relative'
    },
    alert: {
        position: 'absolute',
        width: '100%',
        padding: '0'
    },
}))